// stores/store.js
import { defineStore } from "pinia";

export const useMainStore = defineStore("store", {
  state: () => {
    return {
      user: {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        language: "en",
        email_verified_at: null,
        created_at: null,
        updated_at: null,
        is_staff: false
      },
      workspaces: {
        id: 0,
        name: "",
        logo: "",
        members: {
          users: [
            {
              id: 1,
              user: "",
              profilepicture: "",
              firstname: "",
              lastname: "",
              phonenumber: "",
              email: "",
              role: 0,
              title: "",
              bio: "",
              dateofbirth: "",
              register_date: 0,
              perms: ["userlevel_admin"]
            }
          ],
          count: 2
        },
        theme: {
          primary: "#24a1c7",
          secondary: "#000000",
          accent: "#FF8C00",
          error: "#FF0000",
          info: "#00BFFF",
          success: "#008000",
          warning: "#FFA500"
        },
        subscription: {
          id: "12345",
          plan: "Pro plan",
          status: "active",
          start_date: 0,
          end_date: 0,
          payment_method: "iDeal",
          payment_status: "paid",
          payment_date: 0,
          payment_amount: 0,
          payment_currency: "EUR",
          payment_description: "Pro plan"
        },
        settings: {
          currency: "EUR",
          timezone: "Europe/Amsterdam",
          error_reporting: true,
          error_reporting_email: ""
        }
      },

      ticketSettings: {},
      loadingSettings: false
    };
  },
  actions: {},
  getters: {
    isLoadingSettings(state) {
      return state.loadingSettings;
    }
  }
});
